import { Tab, Tabs } from "@mui/material";
import React from "react";
import { CustomTabPanel } from "./TabPanel";
import QrOverviewPage from "../pages/DynamicQR/QrOverviewPage";
import StaticQRGenerator from "../pages/StaticQR/StaticQRGenerator";
import VCardGenerator from "../pages/VCard/VCardGenerator";

export default function TabContainer() {
    const [tabValue, setTabValue] = React.useState(1);
    return (
        <>
        <Tabs centered value={tabValue} onChange={(event, newValue) => setTabValue(newValue)}>
            <Tab label="Static QR generator" value={1}/>
            <Tab label="vCard generator" value={2}/>
            <Tab label="Dynamic QR codes" value={0}/>
        </Tabs>
        <CustomTabPanel value={tabValue} index={0}>
            <QrOverviewPage />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
            <StaticQRGenerator />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={2}>
            <VCardGenerator />
        </CustomTabPanel>
        </>
    )
}